export default __webpack_public_path__ + "static/media/20_photo.4cdf5786.jpg";